import { render, staticRenderFns } from "./notEmployees.vue?vue&type=template&id=ddb8caf6&scoped=true"
import script from "./notEmployees.vue?vue&type=script&lang=js"
export * from "./notEmployees.vue?vue&type=script&lang=js"
import style0 from "./notEmployees.vue?vue&type=style&index=0&id=ddb8caf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb8caf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb8caf6')) {
      api.createRecord('ddb8caf6', component.options)
    } else {
      api.reload('ddb8caf6', component.options)
    }
    module.hot.accept("./notEmployees.vue?vue&type=template&id=ddb8caf6&scoped=true", function () {
      api.rerender('ddb8caf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/index/notEmployees.vue"
export default component.exports